import React from 'react';
import SurveyPageMultiSelectContainer from './SurveyPageMultiSelectContainer.js';

const SurveyPageCalendarSettingsContainer = (props) => <SurveyPageMultiSelectContainer {...props} noPageNumbers buttonType='toggle' allowNone virtualURL='/virtual/survey-page-calendar-settings' />
export default SurveyPageCalendarSettingsContainer;



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageCalendarSettingsContainer.js